import { authenticatedFetch } from '../utils/authenticatedFetch';
import { configs } from '../configs';

export interface NotificationSettings {
  id?: string;
  criticalThreshold: number;
  lowThreshold: number;
  mediumThreshold: number;
  enabled: boolean;
  inventoryStockEnabled: boolean;
  orderNotificationsEnabled: boolean;
  orderNewEnabled: boolean;
  orderReadyEnabled: boolean;
  orderDeliveredEnabled: boolean;
  orderCancelledEnabled: boolean;
  staffNotificationsEnabled: boolean;
  generalNotificationsEnabled: boolean;
  tenantId?: string;
  createdAt?: string;
  updatedAt?: string;
}

export interface NotificationSettingsResponse {
  success: boolean;
  data: NotificationSettings;
  message?: string;
}

class NotificationSettingsService {
  private apiRoot = configs.apiRoot;

  /**
   * Get notification settings for current tenant
   */
  async getSettings(): Promise<NotificationSettings> {
    const response = await authenticatedFetch(
      `${this.apiRoot}/notification-settings`,
      {
        method: 'GET',
      }
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(
        error.message || `Failed to fetch notification settings: ${response.statusText}`
      );
    }

    const result: NotificationSettingsResponse = await response.json();
    return result.data;
  }

  /**
   * Update notification settings for current tenant
   */
  async updateSettings(
    updates: Partial<NotificationSettings>
  ): Promise<NotificationSettings> {
    const response = await authenticatedFetch(
      `${this.apiRoot}/notification-settings`,
      {
        method: 'PUT',
        body: JSON.stringify(updates),
      }
    );

    if (!response.ok) {
      const error = await response.json();
      throw new Error(
        error.message || `Failed to update notification settings: ${response.statusText}`
      );
    }

    const result: NotificationSettingsResponse = await response.json();
    return result.data;
  }
}

export const notificationSettingsService = new NotificationSettingsService();

